import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { TranslationProvider } from '@ibk/shared-translation';
import { Button, Icon, Loading, RadioInput } from '@ibk/shared-ui';
import { useBenefitContractLocation } from '../../hooks';
import { beneficiosTranslations } from '../../translations';
import { formatLocationAddress } from '../../utils/addressFormatter';
import styles from './AddressListItem.module.css';
function AddressListItemContent({ address, onClickUpdate, onDelete, onDeleteError, onActivate, onActivateError, testIdIdentifier = 'AddressListItem', }) {
    const { activateDeliveryLocation, deleteDeliveryLocation, isDeleting, isActivating, isActivateError } = useBenefitContractLocation();
    useEffect(() => {
        if (isActivateError) {
            onActivateError();
        }
    }, [isActivateError]);
    const handleSelect = async () => {
        if (address.isPrimary) {
            return;
        }
        await activateDeliveryLocation(address.deliveryLocationId);
        onActivate();
    };
    const handleUpdate = () => {
        onClickUpdate(address);
    };
    const handleDelete = async () => {
        try {
            await deleteDeliveryLocation(address.deliveryLocationId);
            onDelete();
        }
        catch (error) {
            onDeleteError(error);
        }
    };
    const addressListItemStyle = [styles.addressListItem, ...(address.isPrimary ? [styles.isPrimary] : [])].join(' ');
    return (_jsxs("div", { className: addressListItemStyle, "data-testid": `view${testIdIdentifier}Container`, children: [_jsx(RadioInput, { disabled: isActivating, selected: address.isPrimary, onClick: handleSelect, dataTestId: `radio${testIdIdentifier}Select` }), _jsxs("div", { className: styles.address, "data-testid": `view${testIdIdentifier}Address`, children: [_jsx("h6", { className: styles.addressTitle, children: address.name }), _jsx("span", { children: formatLocationAddress(address) })] }), _jsxs("div", { className: styles.addressActions, children: [_jsx(Button, { className: styles.buttonAction, variant: 'tertiary', size: 'small', onClick: handleUpdate, dataTestId: `button${testIdIdentifier}Edit`, children: _jsx(Icon, { name: 'actionEdit', width: 14, height: 14 }) }), !address.isPrimary && (_jsx(Button, { className: styles.buttonAction, variant: 'tertiary', size: 'small', onClick: handleDelete, dataTestId: `button${testIdIdentifier}Delete`, disabled: isDeleting, children: isDeleting ? _jsx(Loading, { size: 'micro' }) : _jsx(Icon, { name: 'actionDeleteOrange', width: 14, height: 14 }) }))] })] }));
}
export function AddressListItem(props) {
    return (_jsx(TranslationProvider, { translations: beneficiosTranslations, children: _jsx(AddressListItemContent, { ...props }) }));
}
